import React, { useContext } from "react"
import { NavigationContext } from "../context/Navigation"

export default function Link(props) {
  const { setPath } = useContext(NavigationContext)

  return <div onClick={() => setPath(props.to)}>{props.children}</div>
}
